import React, { useEffect, useRef, useState } from 'react';

// Whack-a-piece: a chess piece pops up in a random cell; tap it before it hops away. Each hit speeds
// the next hop up a touch, so it gets livelier the longer you last. Pure setTimeout + state, no
// assets — a good ~10s filler.
const PIECES = ['♟', '♞', '♝', '♜', '♛', '♚'];
const CELLS = 9; // 3×3

export default function PieceWhack(): React.ReactNode {
  const [active, setActive] = useState(0);
  const [piece, setPiece] = useState(PIECES[0]);
  const [score, setScore] = useState(0);
  const [bonk, setBonk] = useState(false);
  const delay = useRef(850);
  const timer = useRef<number>();

  const hop = () => {
    setActive((prev) => {
      let next = prev;
      while (next === prev) {
        next = Math.floor(Math.random() * CELLS);
      }
      return next;
    });
    setPiece(PIECES[Math.floor(Math.random() * PIECES.length)]);
    timer.current = window.setTimeout(hop, delay.current);
  };

  useEffect(() => {
    timer.current = window.setTimeout(hop, delay.current);
    return () => window.clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const whack = (cell: number) => {
    if (cell !== active) {
      return;
    }
    window.clearTimeout(timer.current);
    setScore((s) => s + 1);
    setBonk(true);
    window.setTimeout(() => setBonk(false), 180);
    delay.current = Math.max(420, delay.current - 45);
    hop();
  };

  return (
    <div className="cm-minigame">
      <div className="cm-minigame-score">
        Whacked <strong>{score}</strong>
      </div>
      <div className="cm-whack-grid">
        {Array.from({ length: CELLS }).map((_, cell) => (
          <button
            key={cell}
            type="button"
            className={`cm-whack-cell${cell === active ? ' is-up' : ''}${
              cell === active && bonk ? ' is-bonk' : ''
            }`}
            onClick={() => whack(cell)}
            aria-label={cell === active ? 'piece' : 'empty'}
          >
            {cell === active ? piece : ''}
          </button>
        ))}
      </div>
    </div>
  );
}
